module.exports = __webpack_public_path__ + "static/media/purchase_item.d3670e56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/purchase_item.svg
// module id = 184
// module chunks = 0